export default [
    {
      header: 'Results',
      title: 'Results',
      icon: 'AwardIcon',
      route: 'results-list',
      resource: 'AdminAccess',
    },
  ]
  